import { DSCardWrapper } from "@components/design-system/molecules";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { View } from "@react-pdf/renderer";
import React from "react";

import DentalChartLegend from "./DentalChartLegend";
import CanineChartWithLabels from "../../../../assets/imgs/charts/Canine-Labels";
import CanineDentalChart from "../../../../assets/imgs/charts/CanineDentalChart"; // Adjust as necessary
import FelineChartWithLabels from "../../../../assets/imgs/charts/Feline-Labels";
import FelineDentalChart from "../../../../assets/imgs/charts/FelineDentalChart"; // Adjust as necessary

const parseDentalRecord = (record = "") => {
  // Initialize conditions object and default type
  const conditions = {};
  let type = "feline";

  // Check for null, undefined, or empty strings explicitly
  if (
    record !== null &&
    record !== undefined &&
    record.trim() !== ""
  ) {
    record
      .trim()
      .split("\n")
      .forEach((line) => {
        const parts = line.split(":").map((part) => part.trim());
        if (parts.length === 2) {
          // Ensure the line splits into exactly two parts
          let [id, condition] = parts;
          id = id.replace(/-\s*/, "");
          if (condition) {
            // Ensure condition is not empty
            conditions[id] = condition;

            if (
              [
                "411",
                "410",
                "110",
                "210",
                "310",
                "311",
                "105",
                "205",
                "305",
                "405",
              ].includes(id)
            ) {
              type = "canine";
            }
          }
        }
      });
  } else {
    console.error("Invalid dental record input:", record);
  }

  return { conditions, type };
};

export default function DentalChart({
  record,
  dentalChartData,
  status,
  isForPDF = false,
  actionSlot,
}) {
  let conditions, type;
  if (dentalChartData) {
    try {
      const parsed =
        typeof dentalChartData === "string"
          ? JSON.parse(dentalChartData)
          : dentalChartData;
      conditions = parsed?.teeth ?? {};
      type = parsed?.species ?? "feline";
    } catch (err) {
      console.error("Failed to parse dentalChartData:", err);
      conditions = {};
      type = "feline";
    }
  } else {
    const result = parseDentalRecord(record);
    conditions = result.conditions;
    type = result.type;
  }
  if (isForPDF) {
    return (
      <View
        style={{
          alignItems: "center",
          height: 500,
        }}
      >
        <DentalChartLegend isForPDF={true} />
        {type === "canine" ? (
          <CanineChartWithLabels toothConditions={conditions} />
        ) : (
          <FelineChartWithLabels toothConditions={conditions} />
        )}
      </View>
    );
  } else {
    return (
      <>
        {!status && (
          <DSCardWrapper variant="warning" padding="p-md">
            <h5 className="text-yellow-600 dark:text-yellow-400 text-sm">
              <FontAwesomeIcon icon={faExclamationCircle} /> Please
              note that the dental chart will only reflect new note
              edits after refreshing the page.
            </h5>
          </DSCardWrapper>
        )}
        <div className="flex flex-col items-center space-y-8 bg-primary p-2 rounded-xl">
          <div className="flex flex-col gap-y-2">
            {actionSlot}
            <DentalChartLegend />
          </div>
          {type === "canine" ? (
            <CanineDentalChart toothConditions={conditions} />
          ) : (
            <FelineDentalChart toothConditions={conditions} />
          )}
        </div>
      </>
    );
  }
}
